import { MenuItem, TextField } from '@mui/material';

export function ActiveStatusFilter(params: { value: any, onChange: (updater: (data: any) => any) => void }) {
    return (
        <TextField
            select
            label="Status"
            name="isActive"
            value={params.value}
            onChange={(event) => {
                params.onChange((_data: any) => ({ ..._data, [event.target.name]: event.target.value }));
            }}
            sx={{ minWidth: 200 }}
        >
            <MenuItem value="true">Active</MenuItem>
            <MenuItem value="false">Inactive</MenuItem>
        </TextField>
    );
}
